// IMPORT PACKAGE REFERENCES
import { combineReducers } from 'redux';

// IMPORT REDUCERS
import { DevicesReducer } from '../reducers/DevicesReducer';
import { UserReducer } from '../reducers/UserReducer';
import { PharmaciesReducer } from '../reducers/PharmaciesReducer';
import { ReportsReducer } from '../reducers/ReportsReducer';

// EXPORT APP REDUCER
export const AppReducer = combineReducers({
    'devicesReducer': DevicesReducer, 'userReducer': UserReducer, 'pharmaciesReducer': PharmaciesReducer, 'reportsReducer': ReportsReducer,
});